import { Divider as MuiDivider, DividerProps } from '@mui/material';

export const Divider = (props: DividerProps) => {
  const { sx, ...otherProps } = props;
  return <MuiDivider sx={{ borderColor: 'Black', mt: 4, mb: 4, ...sx }} {...otherProps} />;
};
